<template>
  <div class="superuser-edit-price">
    <input v-model="newItemPrice" type="number" class="comment__input">

    <div class="comment__actions comment__actions--space">
      <button class="comment__action" @click.prevent="savePrice()">
        {{ tStatic('headerCartNoteSaveLabel') }}
      </button>

      <button class="comment__action" @click="emitDoneEditing()">
        {{ tStatic('headerCartNoteCloseLabel') }}
      </button>
    </div>
  </div>
</template>

<script>
// import httpService from '@/core/http-service'
import { mapActions } from 'vuex'

export default {
  props: {
    cartRow: { type: Object, required: true }
  },
  data: () => ({
    newPrice: null
  }),
  computed: {
    newItemPrice: {
      get() {
        return this.cartRow.price
      },
      set(value) {
        this.newPrice = value.replace(/,/g, '.')
      }
    }
  },
  methods: {
    ...mapActions('commerce', ['setCart']),
    emitDoneEditing() {
      this.$emit('close', this.cartRow.id)
    },
    savePrice() {
      if (this.newPrice !== '') {
        // httpService.post('cart/setPrice', { newPrice: { lineItemId: this.cartRow.id, overridenPrice: this.newPrice } }).then(({ data }) => {
        //   this.setCart(data.data)
        //   this.emitDoneEditing()
        // })
        this.$emit('save-new-price', +this.newPrice)
      }
    }
  }
}
</script>

<style lang="scss">
.superuser-edit-price {
  margin-bottom: measure(quarter);
}
</style>
